import { useMemo } from 'react';
import { GroupDescriptionType } from '@atlas-frontend/sdk';
import { InputDataVersionType } from './types';

export function useSubmittedVersion(
  description?: GroupDescriptionType,
  version?: InputDataVersionType,
) {
  return useMemo(() => {
    return description?.versions?.find((submittedVersion) => {
      if (version === 'active') {
        return submittedVersion.activeVersion;
      } else if (version === 'draft') {
        return submittedVersion.draftVersion;
      }

      return false;
    });
  }, [description?.versions, version]);
}
